import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TRACKING_ID = "G-2RJ1SHBXBF";

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || window.gtag) return;

    const script = document.createElement("script");
    script.id = "p2k-ga-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", TRACKING_ID, { send_page_view: false });
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !window.gtag) return;

    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: location.pathname + location.search + location.hash,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default GoogleAnalytics;
